// extracted by mini-css-extract-plugin
export default {"container":"Counter_container__tJMFJ","counter":"Counter_counter__Qc01w"};